import React from "react";
import { SDLCMetadataConstants } from "@sscs/types";
import { Card } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { useSearchParams } from "react-router";
import { FILE_BROWSER_ROUTES, UNDECLARED_LICENSE, } from "../../../../../constants";
import { LinkToReportTab } from "../../../../common";
import { filterByLicenseFamily } from "../../../../fileBrowser/store/dependenciesSlice";
import { useReportDispatch } from "../../../../hooks";
import { generateFileBrowserLink } from "../../../../utils";
import styles from "./softwareComponent.module.scss";
// TODO: After approval consider refactoring all report cards into one common card
const CounterCard = ({ id, count, label, componentId, componentPath, fileBrowserPage, onClick, }) => {
    const [searchParams] = useSearchParams();
    return (React.createElement("div", { className: styles["counter-card"] },
        React.createElement("span", null, count.toLocaleString()),
        count > 0 ? (React.createElement(LinkToReportTab, { id: id, to: generateFileBrowserLink({
                searchParams,
                componentId,
                componentPath,
                fileBrowserPage,
            }), fullWidth: true, color: "link", className: getClassName(styles.clickable, styles.label), onClick: onClick }, label)) : (React.createElement("div", { className: styles["label"] }, label))));
};
const SoftwareComponent = ({ rowIndex, software, }) => {
    const dispatch = useReportDispatch();
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, null, "Dependencies with license belonging to family"),
        React.createElement(Card.Content, { className: styles["statistics-collection"] }, SDLCMetadataConstants.licenseFamily.map((license) => { var _a; return (React.createElement(CounterCard, { key: license, id: `${rowIndex}-${license}`, count: license
                ? ((_a = software.dependency_licenses[license]) !== null && _a !== void 0 ? _a : 0)
                : software.dependency_licenses.undeclared, label: license ? license : UNDECLARED_LICENSE, componentId: software.identity.uuid, componentPath: software.path, fileBrowserPage: FILE_BROWSER_ROUTES.DEPENDENCIES_ROUTE, onClick: () => dispatch(filterByLicenseFamily(license ? license : UNDECLARED_LICENSE)) })); }))));
};
export default SoftwareComponent;
//# sourceMappingURL=SoftwareComponent.js.map